import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import BookingService from './../../../services/cargobooking.service';
import CONSTANT from './../../../../shared/constants/constant';
import Multiselect from 'vue-multiselect';


export default {
  name: 'Createbookingtype',
  components: {
    VueElementLoading,
    Treeselect,
    Multiselect
  },
  data: function() {
    return {
      mpsNo:"",
      awbtype:"",
      isLoading: false,
      client :null,
      Clientlist:[],
      RouteMode:'',
      totalCount:0,
      tableColumn:['Client Id','Surface AWB Count','Air AWB Count'],
      tableItems:[],
      mpsresult:0,
      clientbusinessaccountid:''
    }
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.isLoading = true;
    await this.getCompanyShortName();
    this.isLoading = false;
    this.getClientAwbCountList();
   },
  methods: {
    async getCompanyShortName(){
      try {
        let InputPayload = {};
        var CompanyShortList = [];
        let result = await ClientService.GetClientListByActiveContracts(InputPayload);
        CompanyShortList = result.data.data.rows;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.Clientlist.push({
          'id': CompanyShortList[i].clientid,
          'label': CompanyShortList[i].clientshortname,
          'ClientBusinessAccountId' : CompanyShortList[i].clientbusinessaccountid,
          });
        }
      } catch(err){
          this.isLoading = false;
          this.$alert(err, "", "error");
          console.log(err);
      }
    },
    selectClient(data){
      if(data){
      this.clientbusinessaccountid = data.ClientBusinessAccountId;
      console.log(data);
      }
    },
    async submitawb(){
      try{
        let inputPayload = {};
        inputPayload.clientid = this.client.id;
        inputPayload.clientBusinessAccountId = this.clientbusinessaccountid;
        inputPayload.routemode = this.RouteMode;
        inputPayload.qty=this.mpsNo;
        inputPayload.awbtype=this.awbtype;
        inputPayload.lastmodifiedby=this.userName;
        this.isLoading = true;
        let awbresult = await BookingService.generateAWB(inputPayload)
        this.isLoading = false;
        if (awbresult.data.code==200)
        {
          this.$alert(awbresult.data.message, "", "success");
        }
        else{
          this.$alert(awbresult.data.message, "", "error");
        }
        this.$router.go();
      }
      catch(err){
        this.isLoading = false;
        this.$alert(err, "", "error");
        console.log(err);
      }
    },
    async generateAWB(){
      try{
        this.$validator.validateAll().then((result) => {
          if(result){
            this.submitawb();
        }
     })
      }
      catch(err){
        this.isLoading = false;
        this.$alert(err, "", "error");
        console.log(err);
    }
    },
    isIntegerOnlty: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
          if (charCode < 48 || charCode > 57) {
            evt.preventDefault();;
          }
          else if(this.mpsNo.length>=5){
            evt.preventDefault();
          }
          else {
            return true;
          }
      },
      async getClientAwbCountList(){
      try {
        this.tableItems=[]
        let inputPayload={};
        this.isLoading = true;
        let result = await BookingService.getClientAwbCountList(inputPayload);
        if(result.data.data.mpsresult){
          this.mpsresult=result.data.data.mpsresult;
        }
        this.totalCount = result.data.data.awbresult.length;
        if(this.totalCount>0){
        let temptableItems = await result.data.data.awbresult;
        let tempArr=[]
        for(var k=0; k<temptableItems.length; k++){
        tempArr.push(this.getClientName(temptableItems[k].clientid));
        }
        for (var i = 0; i < temptableItems.length; i++) {
          this.tableItems.push({
          'ClientId': temptableItems[i].clientid,
          'SurfaceAWBCount': temptableItems[i].surfaceawbcount,
          'AirAWBCount': temptableItems[i].airawbcount,
          "ClientName": tempArr[i]
          });
        }
        }else{
          this.tableItems = [];
        }
        this.isLoading = false;
        } catch(err){
        console.log(err);
        this.isLoading = false;
          }
      },
      getClientName(id) {
        for (var i = 0; i < this.Clientlist.length; i++) {
          if (this.Clientlist[i].ClientBusinessAccountId == id) {
            return this.Clientlist[i].label;
          }
        }
      },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/generateClientAwb/generateClientAwb.component.js